'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsByTagComponent = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newsByTagComponent = exports.newsByTagComponent = {
    template: require('./news-by-tag.html'),
    bindings: {
        recentnews: '<',
        popularnews: '<',
        tags: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$stateParams", "common", "newsService", "newsOverviewService", "Enums", "gettextCatalog", function newsByTagController($scope, $stateParams, common, newsService, newsOverviewService, Enums, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.newsOverviewModel = null;
        vm.$onInit = init;

        function init() {
            var tagId = parseInt($stateParams.id);
            vm.tag = _lodash2.default.find(vm.tags, function (i) {
                return i.id === tagId;
            });

            common.navigationMenu.setNewsActive();
            common.setTitle(gettextCatalog.getString('News for ') + vm.tag.name);
            newsOverviewService.handleGetNews($scope, Enums.newsContext.main.id, { tagId: tagId }).then(function (i) {
                return vm.newsOverviewModel = i;
            });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/news/news-by-tag.js
// module id = 954
// module chunks = 0